import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { useGetGeneralParameters } from "@hooks/useGeneralParams";
import ErrorBox from "../ErrorBox";
import {
  SectionContainer,
  InvoiceOuter,
  HeaderTitle,
  CompanyInfo,
  InvoiceNumber,
} from "./CompanyInvoice.styled";
import UserInfo from "@utils/UserInfo";
import RelatedContacts from "../RelatedContacts";
import { addressSingleLine } from "@utils/utils";

const CompanyInvoice = (props) => {
  const { t, companyData, companyInvoiceError } = props;
  const countryId = UserInfo.countryId();
  const generalParams = useGetGeneralParameters();
  const { countryList } = generalParams;

  return (
    <SectionContainer>
      <InvoiceOuter>
        {companyInvoiceError?.length > 0 && (
          <ErrorBox errors={companyInvoiceError} />
        )}
        <HeaderTitle>
          {t("KICK_OFF_PAGE_SITE_INFORMATION_INVOICING_ADDRESS")}
        </HeaderTitle>
        <CompanyInfo>
          <HeaderTitle color="#0a4986">{companyData?.name}</HeaderTitle>
          <InvoiceNumber>{companyData?.registrationNumber}</InvoiceNumber>
        </CompanyInfo>
        <CompanyInfo paddingLeft="10px">
          <InvoiceNumber marginLeft="0px" fontWeight="400">
            {companyData?.billingAddress && (
              <span
                dangerouslySetInnerHTML={{
                  __html: addressSingleLine(
                    countryId,
                    companyData?.billingAddress,
                    countryList
                  ),
                }}
              ></span>
            )}
          </InvoiceNumber>
        </CompanyInfo>
        <HeaderTitle margin="15px 0 0 0">
          {t("KICK_OFF_PAGE_SITE_INFORMATION_INVOICING_CONTACTS")}
        </HeaderTitle>
        {companyData?.invoicingContacts && (
          <RelatedContacts
            contactList={companyData?.invoicingContacts}
            countryId={countryId}
          />
        )}
      </InvoiceOuter>
    </SectionContainer>
  );
};

CompanyInvoice.propTypes = {};

CompanyInvoice.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(CompanyInvoice);
